/**
 * JWT для API, если HttpOnly-cookie недоступен (кросс-домен, Mini App).
 *
 * Намеренно держим токен только в памяти текущей вкладки:
 * localStorage/sessionStorage делали любой XSS сразу эквивалентом захвата аккаунта.
 */
let apiAccessToken = '';

export function setApiAccessToken(token) {
  if (!token || typeof token !== 'string') return;
  apiAccessToken = token;
}

export function clearApiAccessToken() {
  apiAccessToken = '';
}

export function getApiAccessToken() {
  return apiAccessToken;
}
